exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".EditInfo__surround___26cF_ {\n\tpadding: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.EditInfo__nameText___2dN9d {\n\ttext-transform: capitalize;\n}\n\n.EditInfo__buttonOnlySurround___3OAme {\n\tbackground-color: inherit;\n\theight: inherit;\n}\n\n.EditInfo__buttonOnlyWrapper___eDTSq {\n\tmargin-top: 0;\n}\n\n.EditInfo__profilePicture___1nnA- {\n\tborder-radius: 50%;\n\twidth: 40vw;\n\theight: 40vw;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tbackground-position: center;\n}\n\n.EditInfo__profilePictureSurround___3_7AN {\n\tmargin-top: 2rem;\n    display: flex;\n    flex-flow: column;\n    align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + "",
	"surround": "EditInfo__surround___26cF_",
	"nameText": "EditInfo__nameText___2dN9d",
	"buttonOnlySurround": "EditInfo__buttonOnlySurround___3OAme",
	"buttonOnlyWrapper": "EditInfo__buttonOnlyWrapper___eDTSq",
	"profilePicture": "EditInfo__profilePicture___1nnA-",
	"profilePictureSurround": "EditInfo__profilePictureSurround___3_7AN EditInfo__surround___26cF_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/EditInfo.icss
// module id = 1542
// module chunks = 0